import { render } from "./BgListItem.vue?vue&type=template&id=637fa693"
import script from "./BgListItem.vue?vue&type=script&lang=js"
export * from "./BgListItem.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./BgListItem.vue?vue&type=style&index=0&id=637fa693&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/musubisumu/tex/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__